const allowedTags = ['br', 'b', 'i', 'u', 'strong', 'em']
const htmlTagRegex = /<\/?([a-zA-Z0-9]+)(\s[^>]*)?>/g
const unsafePattern = /on\w+=|javascript:|<script.*?>.*?<\/script>/i

export const isMessageContentValid = (text) => {
  if (unsafePattern.test(text)) {
    return false
  }

  const matches = Array.from(text.matchAll(htmlTagRegex))
  for (const match of matches) {
    const tag = match[1]?.toLowerCase()
    if (tag && !allowedTags.includes(tag)) {
      return false
    }
  }

  return true
}
